import React from 'react';
import { Redirect } from 'react-router-dom';
import Cookie from '../../../assets/js/utils/Cookie';
import axios from "axios";
import Config from "../../../../Config";
import Api from "../../../assets/js/utils/Api";
import PasswordMatch from "../../../assets/js/utils/PasswordMatch";
import LoaderComponent from '../../components/Loader'
import withStyles from "@material-ui/core/styles/withStyles";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import Warning from "../../components/Typography/Warning.jsx";
import CustomSelect from "../../components/CustomInput/CustomSelect";
import BackgroundSlider from "../../components/Slider/BackgroundSlider";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";
import Link from '@material-ui/core/Link';

// @material-ui/icons
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
import Email from "@material-ui/icons/Email";
import AuthIcon from "@material-ui/icons/Lock";
import Icon from "@material-ui/core/Icon";
import EditIcon from "@material-ui/icons/Edit";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import RecaptchaV2 from "../../components/Google/RecaptchaV2";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import signupPageStyle from "../../../assets/jss/material-kit-pro-react/views/signupPageStyle.jsx";

const BusinessSignup = class extends React.Component {
    constructor(props){
        super(props);

        this.store = this.props.store;
        this.history = this.props.history;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resendCode = this.resendCode.bind(this);
        this.confirmSignUp = this.confirmSignUp.bind(this);

        let planId = "4";
        let inviteCode = null;
        if(this.props.match && this.props.match.match && this.props.match.match.params && this.props.match.match.params.inviteCode){
            inviteCode = this.props.match.match.params.inviteCode;
        }
        
        this.state = {
            firstName: '',
            lastName: '',
            email: "",
            password: "",
            passwordConfirm: "",
            accountName: "",
            phone: "",
            cell: "",
            address1: "",
            address2: "",
            address3: "",
            accountType: planId,
            code: "",
            countryId: "",
            stateId: "",
            cityId: "",
            dob: "",
            timezone: "",
            loading: false,
            terms: true,
            promotions: true,
            validation: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                passwordConfirm: '',
                accountName: '',
                code: '',
                countryId: '',
                stateId: '',
                timezone: '',
                businessName: '',
                phone: '',
                isValid: false,
                isValidate: false,
                validateForm: false
            },
            recaptchaToken: "",
            requireLowerletter: false,
            requireUpperletter: false,
            requireNumber: false,
            requireSymbol: false,
            requireLength: false,
            requestCode: false,
            showError: false,
            errorMessage: "",
            user: null,
            advancedFields: false,
            countries: [],
            states: [],
            cities: [],
            loadingCountries: false,
            loadingStates: false,
            loadingCities: false,
            showRecaptcha: true,
            userAccountType:  "business",
            selectAccountType: false,
            businessName: '',
            inviteCode: inviteCode,
            viewPassword: false,
            viewConfirmPassword: false
        };

        this.timezoneOptions = Api.getTimezoneOptions();
    }
    componentDidMount(){
        this.loadCountries();

        if(this.state.accountType !== ""){
            this.canSignup();
        }
    }
    componentWillUnmount(){
        if (this.cancelToken) {
            this.cancelToken.cancel('Request Cancelled')
        }
    }
    canSignup(){
        const that = this;
        const source = axios.CancelToken.source();
        this.cancelToken = source;
        that.setState({
            cancelToken: source,
        });

        let requestData = {
            accountType: this.state.accountType
        }
        Api.canSignup(requestData, source).then(data => {
            if(data.canSignup === false){
                this.setState({
                    loading: false, 
                });

                window.location.href = data.path;
                return;
            }

            that.setState({
                loading: false,
            });
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message")){
                this.setState({
                    loading: false, 
                    showError: true, 
                    cancelToken: null,
                    errorMessage: err.message,
                    advancedFields: false
                });
            }
        });

        this.setState({loading: false, showError: false, cancelToken: source});
    }
    handleChange(e, name){
        let state = {};
        state[name] = e.target.value;
        let limit = 64;
        if(name === "email"){
            limit = 128;
        }
        if(typeof(state[name]) === "string"){
            state[name] = state[name].substr(0, limit);
        }
        if(name === "email"){
            state[name] = state[name].toLowerCase();
        }
        this.setState(state,() => {
            if(name === 'password' || name === 'passwordConfirm'){
                this.validatePassword();
            }
        });
    }
    handleDateChange(date, name) {
        try{
            let parsedDate = new Date(date);
            if(parsedDate === "Invalid Date"){
                return;
            }
            this.setState({
                [name]: parsedDate.toISOString()
           });
        }catch(e){ console.log(e); }        
    }
    handleCheckbox(e, name){
        let state = {};
        state[name] = e.target.checked;
        this.setState(state);
    }
    handleSubmit(e){
        e.preventDefault();
        const isValid = this.validateAdvForm();
        if(!isValid || this.state.loading){
            return;
        }
        let values = this.state;
        const { recaptchaToken } = this.state;
        const requestData = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
            accountName: values.accountName,
            cell: values.cell,
            phone: values.phone,
            address1: values.address1,
            address2: values.address2,
            address3: values.address3,
            accountType: values.accountType,
            countryId: values.countryId,
            stateId: values.stateId,
            cityId: values.cityId,
            dob: values.dob,
            timezone: values.timezone,
            recaptchaToken: recaptchaToken,
            terms: values.terms,
            promotions: values.promotions,
            userType: values.userAccountType,
            businessName: values.businessName,
            signupControl: 1
        };
        if(values.inviteCode){
            requestData['inviteCode'] = values.inviteCode;
        }
        const source = axios.CancelToken.source();
        Api.signUp(requestData, source).then(data => {
            this.setState({
                loading: false, 
                requestCode: true,
                user: data.user
            });
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message")){
                this.setState({
                    loading: false, 
                    showError: true, 
                    cancelToken: null,
                    errorMessage: err.message,
                    advancedFields: false
                });
            }
        });
        this.setState({loading: true, showError: false, cancelToken: source});
    }
    validatePassword(){
        if(this.state.validation.validateForm){
            this.validateForm();
            return;
        }
        let validation = {
            password: "success",
            passwordConfirm: "success",
            isValid: true
        };

        const that = this;
        const check = PasswordMatch.check(this.state.password,function(requireLowerletter, requireUpperletter, requireNumber, requireSymbol, requireLength){
            that.setState({
                showPasswordErrors: true,
                requireLowerletter: requireLowerletter,
                requireUpperletter: requireUpperletter,
                requireNumber: requireNumber,
                requireSymbol: requireSymbol,
                requireLength: requireLength
            });
        });
        
        if(this.state.password.length <= 0 || check === false){
            validation.password = "error";
            validation.isValid = false;
        }
        if(this.state.passwordConfirm.length <= 0 || this.state.password !== this.state.passwordConfirm){
            validation.passwordConfirm = "error";
            validation.isValid = false;
        }
        validation.isValidate = true;

        this.setState({validation: validation});
    }
    validateForm(){
        let validation = {
            email: "success",
            password: "success",
            passwordConfirm: "success",
            isValid: true
        };

        var emailRegex = Config.getEmailRegex();
        if(this.state.email.length <= 0 || !emailRegex.test(this.state.email)){
            validation.email = "error";
            validation.isValid = false;
        }
        
        const that = this;
        const check = PasswordMatch.check(this.state.password,function(requireLowerletter, requireUpperletter, requireNumber, requireSymbol, requireLength){
            that.setState({
              showPasswordErrors: true,
              requireLowerletter: requireLowerletter,
              requireUpperletter: requireUpperletter,
              requireNumber: requireNumber,
              requireSymbol: requireSymbol,
              requireLength: requireLength
            });
        });
        if(this.state.password.length <= 0 || check === false){
            validation.password = "error";
            validation.isValid = false;
        }
        if(this.state.passwordConfirm.length <= 0 || this.state.password !== this.state.passwordConfirm){
            validation.passwordConfirm = "error";
            validation.isValid = false;
        }

        if(this.state.timezone.length <= 2){
            validation.timezone = "error";
            validation.isValid = false;
        }
        validation.isValidate = true;
        validation.validateForm = true;
        
        this.setState({validation: validation});
        return validation.isValid;
    }
    validateAdvForm(){
        let validation = this.state.validation;
        validation.countryId = 'success';
        validation.stateId = 'success';
        validation.businessName = "success";
        validation.isValid = true;
        validation.firstName = "success";
        validation.lastName = "success";
        validation.phone = "success";

        if(this.state.firstName.trim().length <= 0){
            validation.firstName = "error";
            validation.isValid = false;
        }
        if(this.state.lastName.trim().length <= 0){
            validation.lastName = "error";
            validation.isValid = false;
        }
        if(this.state.businessName.trim().length <= 0){
            validation.businessName = "error";
            validation.isValid = false;
        }
        if(this.state.phone.trim().length <= 0){
            validation.phone = "error";
            validation.isValid = false;
        }
        if(this.state.countryId.length <= 2){
            validation.countryId = "error";
            validation.isValid = false;
        }
        if(this.state.states.length > 0 && this.state.stateId.length <= 0){
            validation.stateId = "error";
            validation.isValid = false;
        }

        if(this.state.recaptchaToken.length <= 0){
            validation.isValid = false;
        }
        if(!this.state.terms){
            validation.isValid = false;
        }
        validation.isValidate = true;

        this.setState({validation: validation});
        return validation.isValid;
    }
    resendCode(event){
        event.preventDefault();
        event.stopPropagation();
        const requestData = {
            email: this.state.email,
        };
        const source = axios.CancelToken.source();
        Api.resendCode(requestData, source).then(data => {
            this.setState({
                loading: false, 
            });
        }).catch(err => {
            
        });
        this.setState({loading: true, showError: false, cancelToken: source});
    }
    confirmSignUp(event){
        event.preventDefault();
        event.stopPropagation();
        if (this.state.code.length <= 0) {
            this.setState({
                ...this.state,
                validation: {
                    ...this.state.validation,
                    code: "error"
                }
            });
            return;
        }
        const source = axios.CancelToken.source();
        const code = this.state.code;
        this.setState({loading: true, showError: false, cancelToken: source});
        const requestData = {
            code: code,
            email: this.state.email,
            cancelToken: source
        };
        Api.confirmSignUp(requestData, source).then(data => {
            Cookie.write("oauth_token", data.oauth_token);
            Cookie.write("oauth_secret", data.oauth_secret);
            Cookie.write("expires_at", data.expires_at);
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            if(data.hasOwnProperty("checkout_url")){
                window.location.href = data.checkout_url;
                return;
            }
            this.history.push("/user/business-info");
            this.store.dispatch({
                type: "LOGIN",
                state: {
                    authorized: true,
                    user: data.user
                }
            }); 
        }).catch(err => {
            if(typeof(err) === "object" && err.hasOwnProperty("message")){
                this.setState({
                    loading: false, 
                    showError: true, 
                    cancelToken: null,
                    errorMessage: err.message
                });
            }
        });;
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<GridItem key={key} className={"passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </GridItem>);
                key++;
            }
            return errorMessages;
        }
        return <GridItem className={"passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </GridItem>;
    }
    showAdvancedFields(){
        const isValid = this.validateForm();
        if(!isValid){
            return;
        }
        this.setState({advancedFields: true});
    }
    hideAdvancedFields(){
        this.setState({advancedFields: false});
    }
    showFields(){
        this.setState({advancedFields: false, selectAccountType: false});
    }
    loadCountries(){
        const that = this;
        const source = axios.CancelToken.source();
        this.cancelToken = source;
        that.setState({
            cancelToken: source,
            loadingCountries: true,
            countries: []
        });
        Api.getCountries(source).then(data => {
            that.setState({
                countries: data.response,
                loadingCountries: false
            });
        }).catch(err => {
            console.log(err);
        });
    }
    onCountryChange(e){
        const country = e.target.value;
        this.loadStates(country);
    }
    loadStates(country){
        const { countryId } = this.state;
        if(countryId === country){
            return;
        }
        const that = this;
        const source = axios.CancelToken.source();
        this.cancelToken = source;
        that.setState({
            cancelToken: source,
            loadingStates: true,
            countryId: country,
            states: [],
            stateId: "",
            cities: [],
            cityId: ""
        });
        Api.getStates(country, source).then(data => {
            that.setState({
                states: data.response,
                loadingStates: false
            });
        }).catch(err => {
            console.log(err);
        });
    }
    onStateChange(e){
        const state = e.target.value;
        this.loadCities(state);
    }
    loadCities(state){
        const { stateId } = this.state;
        if(stateId === state){
            return;
        }
        const that = this;
        const source = axios.CancelToken.source();
        this.cancelToken = source;
        const { countryId } = this.state;
        that.setState({
            cancelToken: source,
            loadingCities: true,
            stateId: state,
            cities: [],
            cityId: ""
        });
        Api.getCities(countryId, state, source).then(data => {
            that.setState({
                cities: data.response,
                loadingCities: false
            });
        }).catch(err => {
            console.log(err);
        });
    }
    onRecaptcha(token){
        this.setState({
            showRecaptcha: false,
            recaptchaToken: token
        });
    }
    handleUserAccountType(name, value){
        this.setState({
            [name]: value
        });
    }
    renderCountries(){
        const { classes } = this.props;
        const { validation } = this.state;
        const {  countries, states, cities, loadingCountries, loadingStates, loadingCities } = this.state;
        return (
            <>
                {
                    countries.length > 0 ?
                        <CustomSelect 
                            formControlProps={{
                                fullWidth: true
                            }}
                            labelText="Country"
                            success={validation.countryId === "success"}
                            error={validation.countryId === "error"}
                            selectProps={{
                                onChange: (e) => this.onCountryChange(e),
                                value: this.state.countryId
                            }}
                            inputProps={{
                                name: "countryId",
                                id: "input-countryId",
                                className: classes.alignLeft
                            }}
                            items={countries}
                            itemLabel="name"
                            itemValue="id"
                        />
                    :
                        loadingCountries ?
                            <LoaderComponent align="left" />
                        :
                        <></>
                }
                {
                    states.length > 0 ?
                        <CustomSelect 
                            formControlProps={{
                                fullWidth: true
                            }}
                            labelText="State / Province"
                            success={validation.stateId === "success"}
                            error={validation.stateId === "error"}
                            selectProps={{
                                onChange: (e) => this.onStateChange(e),
                                value: this.state.stateId
                            }}
                            inputProps={{
                                name: "stateId",
                                id: "input-stateId",
                                className: classes.alignLeft
                            }}
                            items={states}
                            itemLabel="name"
                            itemValue="id"
                        />
                    :
                        loadingStates ?
                            <LoaderComponent align="left" />
                        :
                        <></>
                }
                {
                    cities.length > 0 ?
                        <CustomSelect 
                            formControlProps={{
                                fullWidth: true
                            }}
                            labelText="City"
                            selectProps={{
                                onChange: (e) => this.handleChange(e, "cityId"),
                                value: this.state.cityId
                            }}
                            inputProps={{
                                name: "cityId",
                                id: "input-cityId",
                                className: classes.alignLeft
                            }}
                            items={cities}
                            itemLabel="name"
                            itemValue="id"
                        />
                    :
                        loadingCities ?
                            <LoaderComponent align="left" />
                        :
                        <></>
                }
            </>
        )
    }
    onViewPassword(name = 'viewPassword'){
        let state = {};
        if(name  === 'viewPassword'){
            state['viewPassword'] = !this.state.viewPassword;
        }else if(name === 'viewConfirmPassword'){
            state['viewConfirmPassword'] = !this.state.viewConfirmPassword;
        }
        this.setState(state);
    }
    renderBusinessSignup(){
        const { classes } = this.props;
        const { validation, advancedFields } = this.state;
        const { requireLowerletter, requireUpperletter, requireNumber, requireSymbol, requireLength, password, passwordConfirm, 
            showRecaptcha, viewPassword, viewConfirmPassword } = this.state;
        const showPasswordErrors = (validation.password === "success" || validation.password === "error");
        const showPasswordConfirmErrors = (validation.passwordConfirm === "success" || validation.passwordConfirm === "error");
        const requirePasswordConfirm = (passwordConfirm.length > 0 && password === passwordConfirm);
        if(!advancedFields){
            return(
                <>
                    <CustomInput
                        formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses
                        }}
                        success={validation.email === "success"}
                        error={validation.email === "error"}
                        id="input-email"
                        inputProps={{
                            onChange: (e) => this.handleChange(e, 'email'),
                            name: "email",
                            value: this.state.email,
                            startAdornment: (
                                <InputAdornment position="start" className={classes.inputAdornment} >
                                    <Email className={classes.inputAdornmentIcon}/>
                                </InputAdornment>
                            ),
                            placeholder:"Email",
                            type: "email"
                        }}
                    />
                    <p className={classes.verificationNote}>A verification code will be sent to this email to complete registration.</p>
                    <CustomInput
                        formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses
                        }}
                        success={validation.password === "success"}
                        error={validation.password === "error"}
                        id="input-password"
                        passwordInput={viewPassword ? false : true}                                        
                        inputProps={{
                            onChange: (e) => this.handleChange(e,'password'),
                            name: "password",
                            type: "text",
                            value: password,
                            placeholder:"Password",
                            autoComplete: 'off',
                            startAdornment: (
                                <InputAdornment position="start" className={classes.inputAdornment}>
                                    <Icon className={classes.inputAdornmentIcon}>lock_outline </Icon>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment 
                                    position="end" 
                                    className={classes.inputAdornment+' viewPasswordIcon'} 
                                    onClick={() => this.onViewPassword('viewPassword') }
                                >
                                    {
                                        password ?
                                            viewPassword ?
                                                <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                            :
                                                <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                        :
                                            <></>
                                    }
                                </InputAdornment>
                            ),
                        }}
                    />
                    {
                        showPasswordErrors || password.length > 0 ?
                            <GridItem>
                                <div>
                                    <div className={(requireLowerletter?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-lowerletter"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-lowerletter">{requireLowerletter? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-lowerletter">Password must contain a lower case letter</span>
                                    </div>
                                    <div className={(requireUpperletter?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-upperletter"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-upperletter">{requireUpperletter? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-upperletter">Password must contain an upper case letter</span>
                                    </div>
                                    <div className={(requireNumber?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-numbers"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-symbols">{requireNumber? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-symbols">Password must contain a number</span>
                                    </div>
                                    <div className={(requireSymbol?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-symbols"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-numbers">{requireSymbol? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-numbers">Password must contain a special character</span>
                                    </div>
                                    <div className={(requireLength?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-length"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-length">{requireLength? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-length">Password must contain at least 8 characters</span>
                                    </div>
                                </div>
                            </GridItem>
                        :
                        <></>
                    }
                    <CustomInput
                        success={validation.passwordConfirm === "success"}
                        error={validation.passwordConfirm === "error"}
                        id="input-signupPasswordConfirm"
                        passwordInput={viewConfirmPassword ? false : true}
                        inputProps={{
                            required: true,
                            onChange: (e) => this.handleChange(e,'passwordConfirm'),
                            name: "passwordConfirm",
                            type: "text",
                            value: passwordConfirm,
                            placeholder:"Type Password Again",
                            autoComplete: 'off',
                            startAdornment: (
                                <InputAdornment position="start" className={classes.inputAdornment}>
                                    <Icon className={classes.inputAdornmentIcon}>lock_outline </Icon>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment 
                                    position="end" 
                                    className={classes.inputAdornment+' viewPasswordIcon'} 
                                    onClick={() => this.onViewPassword('viewConfirmPassword') }
                                >
                                    {
                                        passwordConfirm ?
                                            viewConfirmPassword ?
                                                <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                            :
                                                <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                        :
                                            <></>
                                    }
                                </InputAdornment>
                            ),
                        }}                                    
                        formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses
                        }}
                    />
                    {
                        showPasswordConfirmErrors ?
                            <GridItem>
                                <div>
                                    <div className={(requirePasswordConfirm?"passwordCheck-valid-customizable":"passwordCheck-notValid-customizable")+" checkPassword-lowerletter"}>
                                        <span aria-hidden="true" className="validation-error-symbol check-lowerletter">{requirePasswordConfirm? '\u2713' : '\u2716' }</span>
                                        <span className="checkPasswordText-lowerletter">Password do not match</span>
                                    </div>
                                </div>
                            </GridItem>
                        :
                        null
                    }
                    <CustomSelect 
                        formControlProps={{
                            fullWidth: true
                        }}
                        labelText="Timezone"
                        selectProps={{
                            onChange: (e) => this.handleChange(e,"timezone"),
                            value: this.state.timezone
                        }}
                        inputProps={{
                            name: "timezone",
                            id: "input-timezone",
                            className: classes.alignLeft
                        }}
                        success={validation.timezone === "success"}
                        error={validation.timezone === "error"}
                        items={this.timezoneOptions}
                        itemLabel="value"
                        itemValue="key"
                    />
                </>
            )
        }
        return (
            <>
                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                    }}
                    success={validation.firstName === "success"}
                    error={validation.firstName === "error"}
                    id="input-firstName"
                    inputProps={{
                        onChange: (e) => this.handleChange(e, 'firstName'),
                        name: "firstName",
                        value: this.state.firstName,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment} >
                                <EditIcon className={classes.inputAdornmentIcon}/>
                            </InputAdornment>
                        ),
                        placeholder:"Legal First Name"
                    }}
                />
                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                    }}
                    success={validation.lastName === "success"}
                    error={validation.lastName === "error"}
                    id="input-lastName"
                    inputProps={{
                        onChange: (e) => this.handleChange(e, 'lastName'),
                        name: "lastName",
                        value: this.state.lastName,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment} >
                                <EditIcon className={classes.inputAdornmentIcon}/>
                            </InputAdornment>
                        ),
                        placeholder:"Legal Last Name"
                    }}
                />
                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                    }}
                    success={validation.businessName === "success"}
                    error={validation.businessName === "error"}
                    id="input-businessName"
                    inputProps={{
                        onChange: (e) => this.handleChange(e, 'businessName'),
                        name: "businessName",
                        value: this.state.businessName,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment} >
                                <EditIcon className={classes.inputAdornmentIcon}/>
                            </InputAdornment>
                        ),
                        placeholder:"Legal Business Name"
                    }}
                />
                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                    }}
                    success={validation.phone === "success"}
                    error={validation.phone === "error"}
                    id="input-phone"
                    inputProps={{
                        onChange: (e) => this.handleChange(e, 'phone'),
                        name: "phone",
                        value: this.state.phone,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment} >
                                <EditIcon className={classes.inputAdornmentIcon}/>
                            </InputAdornment>
                        ),
                        placeholder:"Business Phone"
                    }}
                />
                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses
                    }}
                    id="input-address1"
                    inputProps={{
                        onChange: (e) => this.handleChange(e, 'address1'),
                        name: "address1",
                        value: this.state.address1,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment} >
                                <EditIcon className={classes.inputAdornmentIcon}/>
                            </InputAdornment>
                        ),
                        placeholder:"Street Address"
                    }}
                />
                
                {this.renderCountries()}

                <FormControlLabel
                    classes={{label: classes.label+" "+(this.state.terms ? '' : classes.termsError)}}
                    control={
                        <Checkbox                                                
                            tabIndex={-1}
                            onClick={(e) => this.handleCheckbox(e, "terms")}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{checked: classes.checked, root: classes.checkRoot}}
                            checked={(this.state.terms)}
                        />
                    }
                    label={
                        <span>I agree to Sendlinx's <Link href="https://sendlinx.com/terms-of-use/" target="_blank">Term of Use</Link> & <Link href="https://sendlinx.com/privacy-policy/" target="_blank">Privacy Policy</Link></span>
                    }
                />
                <div className={classes.recaptcha}>
                    <RecaptchaV2 onChange={(response) => this.onRecaptcha(response)} show={showRecaptcha} />
                </div>
            </>
        )
    }
    render() {
        const { classes } = this.props;
        const { validation, loading, requestCode, showError, advancedFields } = this.state;
        const { authorized } = this.store.getState();
        if(authorized){
            return <Redirect to='/' />
        }
        return (
            <div>
                <div className={classes.container}>
                    <GridContainer justifyContent="center">
                    <GridItem xs={12} sm={10} md={6}>
                        <Card className={classes.cardSignup+(validation.isValidate ? ' validate' : '')}>
                        <h2 className={classes.cardTitle}>Sign up & Start Sending</h2>
                        <CardBody>
                            <GridContainer justifyContent="center">
                                <GridItem xs={12} sm={12} md={12}>
                                    {
                                        requestCode ?
                                            <div>
                                                <GridItem>
                                                    <Warning>
                                                        We’ve sent a verification code to your email. If you don’t see it in your inbox, please check your <span>spam or junk folder</span>. Enter the code below to confirm your account.
                                                    </Warning>
                                                </GridItem>
                                                <GridContainer>
                                                    <GridItem>
                                                        {
                                                            showError ?
                                                                this.renderErrorMessages()
                                                            :
                                                            <></>
                                                        }
                                                        <form onSubmit={this.confirmSignUp} noValidate>
                                                            <GridItem>                             
                                                                <CustomInput
                                                                    success={validation.code === "success"}
                                                                    error={validation.code === "error"}
                                                                    id="input-code"
                                                                    inputProps={{
                                                                        required: true,
                                                                        onChange: (e) => this.handleChange(e,'code'),
                                                                        name: "code",
                                                                        type: "text",
                                                                        startAdornment: (
                                                                            <InputAdornment position="start" className={classes.inputAdornment} >
                                                                                <VerifiedUser className={classes.inputAdornmentIcon}/>
                                                                            </InputAdornment>
                                                                        ),
                                                                        placeholder:"Verification Code"
                                                                    }}                                    
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                />
                                                            </GridItem>                              
                                                            <GridItem>
                                                                {
                                                                    loading ?
                                                                        <LoaderComponent />
                                                                    :
                                                                        <>
                                                                        <Button type="submit" color="primary" round>
                                                                            <AuthIcon className={classes.icons} /> Confirm Account
                                                                        </Button>
                                                                        <p className="redirect-customizable text-center mt-2"><span>Didn't receive a code?</span>&nbsp;<span className={classes.anchor} onClick={(e) => this.resendCode(e)}>Resend it</span></p>
                                                                        </>
                                                                }
                                                                
                                                            </GridItem>
                                                        </form>
                                                    </GridItem>
                                                </GridContainer>                        
                                            </div>
                                        :
                                        <>
                                            {
                                                showError ?
                                                    this.renderErrorMessages()
                                                :
                                                <></>
                                            }
                                            <form className={classes.form}>
                                                {
                                                    this.renderBusinessSignup()
                                                }
                                                <div className={classes.textCenter+" "+(advancedFields ? classes.alignButtons : '')}>
                                                    {
                                                        loading ?
                                                            <LoaderComponent />
                                                        :
                                                            advancedFields ?
                                                                <>
                                                                    <Button round color="primary" onClick={() => this.hideAdvancedFields()}>Back</Button>
                                                                    <Button round color="primary" onClick={this.handleSubmit}>Signup</Button>
                                                                </>
                                                            :
                                                                <Button round color="primary" onClick={() => this.showAdvancedFields()}>Next</Button>
                                                    }                                        
                                                </div>
                                            </form>
                                        </>
                                    }
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        </Card>
                    </GridItem>
                    </GridContainer>
                </div>
                <BackgroundSlider store={this.store} />
            </div>
        )
    }
}

export default withStyles(signupPageStyle)(BusinessSignup);